<template>
  <Teleport to="body">
    <div>
      <div
        aria-live="assertive"
        class="pointer-events-none fixed inset-0 z-60 flex items-start px-4 py-6 sm:p-6"
      >
        <div class="flex w-full flex-col items-center space-y-4">
          <transition-group
            enter-active-class="transform ease-out duration-300 transition"
            enter-from-class="translate-y-2 opacity-0"
            enter-to-class="translate-y-0 opacity-100"
            leave-active-class="transition ease-in duration-100"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <div
              v-for="messageObject in topMessages"
              :key="messageObject.id"
              class="pointer-events-auto relative w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5"
            >
              <NotificationItem
                v-if="messageObject.options?.notification"
                :notification="messageObject.options.notification"
                variant="toast"
              />
              <div v-else :class="['p-4', messageObject?.options?.bg || '']">
                <div class="flex items-start">
                  <div class="shrink-0"></div>
                  <div class="ml-3 w-0 flex-1 pt-0.5 pr-6">
                    <p class="text-sm font-normal text-gray-900">{{ messageObject.message }}</p>
                  </div>
                </div>
              </div>
              <button
                type="button"
                data-test="toast-close-button"
                class="absolute top-4 right-4 inline-flex rounded-md bg-transparent text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
                @click="handleClose(messageObject.id)"
              >
                <span class="sr-only">Close</span>
                <XIcon class="h-5 w-5" aria-hidden="true" />
              </button>
            </div>
          </transition-group>
        </div>
      </div>

      <div
        aria-live="assertive"
        class="pointer-events-none fixed inset-0 z-60 flex items-end px-4 py-6 sm:p-6"
      >
        <div class="flex w-full flex-col items-center space-y-4">
          <transition-group
            enter-active-class="transform ease-out duration-300 transition"
            enter-from-class="translate-y-2 opacity-0"
            enter-to-class="translate-y-0 opacity-100"
            leave-active-class="transition ease-in duration-100"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
          >
            <div
              v-for="messageObject in bottomMessages"
              :key="messageObject.id"
              class="pointer-events-auto w-full max-w-sm overflow-hidden rounded-lg bg-white shadow-lg ring-1 ring-black/5"
              :class="{
                'bg-error-100 ring-error-500': messageObject.options?.type === 'error'
              }"
            >
              <div :class="['p-4', messageObject?.options?.bg || '']">
                <div class="flex items-start">
                  <div class="shrink-0"></div>
                  <div class="ml-3 w-0 flex-1 pt-0.5">
                    <p class="text-sm font-normal text-gray-900">{{ messageObject.message }}</p>
                  </div>
                  <div class="ml-4 flex shrink-0">
                    <button
                      type="button"
                      class="inline-flex rounded-md bg-transparent text-gray-400 hover:text-gray-500 focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:outline-hidden"
                      @click="handleClose(messageObject.id)"
                    >
                      <span class="sr-only">Close</span>
                      <XIcon class="h-5 w-5" aria-hidden="true" />
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </transition-group>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import useToast from '@/hooks/use-toast.js'
import { XIcon } from '@heroicons/vue/solid'
import { computed } from 'vue'
import NotificationItem from '@/components/notifications/NotificationItem.vue'

const { messages, removeMessage } = useToast()

const topMessages = computed(() =>
  messages.value.filter((message) => message.options?.position === 'top')
)
const bottomMessages = computed(() =>
  messages.value.filter(
    (message) => message.options?.position === 'bottom' || !message.options?.position
  )
)

const handleClose = (messageId) => {
  removeMessage(messageId)
}
</script>
